module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-5.eef0b0a4.png";